
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Alert } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Banner = () => {
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchBanner();
  }, []);

  const fetchBanner = async () => {
    try {
      const res = await axios.get("https://api.bigfresh.in/fetch-banner");
      setBanners(res.data.bannerDetail);
    } catch (error) {
      console.error("API Error:", error);
      setShowError(true);
      setErrorMessage("Failed to load banners.");
    }
  };

  // Move to the next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  // Move to the previous slide
  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex === 0 ? banners.length - 1 : prevIndex - 1)
    );
  };

  if (banners.length === 0) return <div>No banners available</div>;

  return (
    <div className="dashboard-container">
      <div className="main-dashboard">
        {showError && <Alert variant="danger">{errorMessage}</Alert>}

        <div id="bannerCarousel" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            {banners.map((banner, index) => {
              if (!banner?.img) return null;

              const cleanPath = banner.img
                .replace(/\\/g, "/")
                .replace(/^\/?uploads\//, "");
              const fileUrl = `https://api.bigfresh.in/uploads/${cleanPath}`;

              // If it's a video, display it
              if (cleanPath.endsWith(".mp4")) {
                return (
                  <div
                    key={banner.id}
                    className={`carousel-item ${index === currentIndex ? "active" : ""}`}
                  >
                    <video
                      src={fileUrl}
                      className="d-block w-100"
                      autoPlay
                      muted
                      loop
                      style={{ maxHeight: "350px", objectFit: "cover" }}
                      onError={() => console.error("Video failed to load")}
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                );
              }

              // If it's an image (GIF, JPG, PNG), display it
              if (cleanPath.endsWith(".gif") || cleanPath.endsWith(".jpg") || cleanPath.endsWith(".png")) {
                return (
                  <div
                    key={banner.id}
                    className={`carousel-item ${index === currentIndex ? "active" : ""}`}
                  >
                    <img
                      src={fileUrl}
                      className="d-block w-100"
                      alt="banner"
                      style={{ maxHeight: "350px", objectFit: "cover" }}
                      onError={() => console.error("Image failed to load")}
                    />
                  </div>
                );
              }

              return null;
            })}
          </div>

        </div>

        <ToastContainer />
      </div>
    </div>
  );
};

export default Banner;
